import { type FormEvent, useState } from 'react'

import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'
import { Field, FieldLabel, FieldSeparator } from '@/components/ui/field'
import { GoogleSignInButton } from '@/components/ui/google-sign-in-button'
import { Input } from '@/components/ui/input'

/** First step of signing in: Google, or the email to send a code to. */
export function SignInEmailStep({
  initialEmail,
  isSending,
  errorMessage,
  onSubmit,
  onGoogle,
}: {
  initialEmail: string
  isSending: boolean
  errorMessage?: string
  onSubmit: (email: string) => void
  onGoogle?: () => void
}) {
  const [email, setEmail] = useState(initialEmail)

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    if (!isSending) onSubmit(email.trim())
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      {errorMessage && (
        <Banner variant="error" small>
          {errorMessage}
        </Banner>
      )}
      {onGoogle && (
        <>
          <GoogleSignInButton className="w-full" onClick={onGoogle} />
          {/* The label sits on the card, not the page background the separator assumes. */}
          <FieldSeparator className="*:data-[slot=field-separator-content]:bg-card my-1">or</FieldSeparator>
        </>
      )}
      <Field>
        <FieldLabel htmlFor="sign-in-email">Email</FieldLabel>
        <Input
          id="sign-in-email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="Enter your email address"
          autoFocus
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          disabled={isSending}
        />
      </Field>
      <Button type="submit" className="w-full" loading={isSending ? 'Sending your code…' : undefined}>
        Continue
      </Button>
    </form>
  )
}
